import { observer } from 'mobx-react-lite'

import { PricesConfig, PriceTypesMatching, PriceTypesMatchingBaseProps } from '../PriceTypesMatching'

import { WbAccountModel } from '../../../server/mpsklad_core/Models/WbAccountModel'
import { WbPriceTypesModel } from '../../../server/mpsklad_core/Models/WbPriceTypesModel'

export const WildberriesPriceTypesMatching =
  observer(
    ({account, onChange}: PriceTypesMatchingBaseProps<WbAccountModel, WbPriceTypesModel>) =>
      <PriceTypesMatching<WbAccountModel, WbPriceTypesModel>
        account={account}
        pricesConfig={pricesConfig}
        initialPriceIds={{
          msBasePriceId: account.msBasePriceId,
          msPriceId: account.msPriceId
        }}
        onChange={onChange}
      />)

const pricesConfig = {
  msBasePriceId: 'Цена Wildberries без скидки',
  msPriceId: 'Цена Wildberries'
} as const satisfies PricesConfig<WbPriceTypesModel>